import { SUPPORT_PHONE } from "../constants/defaults";

const handleCall = () => {
  const phone = SUPPORT_PHONE?.split(" ")?.join("");
  window.location.href = `tel:+${phone}`;
};

const openAppLink = () => {
  const path = window.location.pathname;

  const link = {
    "/shelf":
      "https://play.google.com/store/apps/details?id=com.rafu.stores.app",
    "/": "https://play.google.com/store/apps/details?id=com.rafu.sellers.app",
  };

  window.open(link[path]);
};

const Helper = {
  handleCall,
  openAppLink,
};

export default Helper;
